var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { MOUNT_POINT_WINDOWS } from '@lucidlink/sdk';
import { InlineForm, TextInputField, translate } from '@lucidlink/uicore';
import { useFormRoot } from '@lucidlink/uicore/form-builder';
import { PII_MASK_CLASS } from '#constants';
import { DEPENDENCY_KEYS, useDependency } from '#context';
const WINDOWS_MOUNT_POINT_ID = 'windows-mount-point';
export const WindowsMountPoint = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_2();
    const { handleToasts } = useDependency(DEPENDENCY_KEYS.UseFilespaceSettingsToasts)({
        filespaceId,
        workspaceId,
        settingName: MOUNT_POINT_WINDOWS,
    });
    const { formData: { windowsMountPoint: formWindowsMountPoint = '' }, } = useFormRoot();
    const { mutation: { isSuccess, mutate: setGlobalSettings }, } = useDependency(DEPENDENCY_KEYS.UseSetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_WINDOWS,
    }, {
        onSuccess: () => {
            handleToasts();
        },
    });
    const setWindowsMountPoint = useCallback(() => setGlobalSettings([
        { fullName: MOUNT_POINT_WINDOWS, value: formWindowsMountPoint },
    ]), [formWindowsMountPoint, setGlobalSettings]);
    const { default: defaultValue, isDefault, value } = data;
    const autoGenerated = translate('Auto generated');
    const { mutation: { mutate: unsetGlobalSetting }, } = useDependency(DEPENDENCY_KEYS.UseUnsetGlobalSettings)({
        filespaceId,
        workspaceId,
        setting: MOUNT_POINT_WINDOWS,
    }, {
        onSuccess: () => {
            handleToasts({ isReset: true });
        },
    });
    const unsetWindowsMountPoint = useCallback(() => {
        unsetGlobalSetting([MOUNT_POINT_WINDOWS]);
    }, [unsetGlobalSetting]);
    const onMountPointReset = useDependency(DEPENDENCY_KEYS.UseOnMountPointReset)();
    const resetMountPoint = useCallback(() => {
        if (onMountPointReset) {
            onMountPointReset({
                defaultMountPoint: defaultValue || autoGenerated,
                mountPoint: MOUNT_POINT_WINDOWS,
                reset: unsetWindowsMountPoint,
            });
        }
        else {
            unsetWindowsMountPoint();
        }
    }, [
        autoGenerated,
        defaultValue,
        onMountPointReset,
        unsetWindowsMountPoint,
    ]);
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: resetMountPoint,
            tooltip: translate(`The default value is: {{value}}`, {
                value: defaultValue || autoGenerated,
            }),
        };
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = useMemo(() => [
        translate('Windows only. Specify the path or drive letter where the filespace will be mounted.'),
        translate('Accepted options:'),
        translate('Drive letter (e.g "L:")'),
        translate('Full folder path (e.g. "C:\\Users\\myuser\\mount")'),
        translate('Network path ( e.g. "\\\\lucid\\myfilespace")'),
    ], []);
    return (_jsx(InlineForm, { cancelAriaLabel: translate('cancel'), "data-testid": WINDOWS_MOUNT_POINT_ID, formElement: (labelProps) => (_jsx(TextInputField, { ...labelProps, autoFocus: true, "data-testid": WINDOWS_MOUNT_POINT_ID, id: WINDOWS_MOUNT_POINT_ID, initialValue: value, name: "windowsMountPoint" })), inputId: WINDOWS_MOUNT_POINT_ID, isSaveAllowed: value !== formWindowsMountPoint, isSuccess: isSuccess, label: translate('Windows mount point'), labelDefault: labelDefault, labelTooltip: labelTooltip, onSave: setWindowsMountPoint, resetToDefault: resetToDefault, saveAriaLabel: translate('Save'), tooltipPosition: "right", value: value || autoGenerated, valueClassName: PII_MASK_CLASS, width: "sm" }));
};
_react_refresh_temp_1 = WindowsMountPoint;
$RefreshReg$(_react_refresh_temp_1, "WindowsMountPoint");
_react_refresh_temp_2(WindowsMountPoint, "tsIzC6KnPubyILl5cA6UKby9Zuc=", false, () => [useDependency, useFormRoot, useDependency, useDependency, useDependency]);
